export default __webpack_public_path__ + "static/product-4722f7c64857e08644c28bd519023011.png";